import { useState, useEffect, useRef } from 'react';
import { EditorState, convertToRaw, ContentState, convertFromHTML } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';

const DescriptionEditor = ({ onChange, placeholder, value = "" }) => {
  
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const isSelfUpdateRef = useRef(false);
  const initializedRef = useRef(false);

  useEffect(() => {
    if (isSelfUpdateRef.current) {
      isSelfUpdateRef.current = false;
      return;
    }

    if (value) {
      const blocksFromHTML = convertFromHTML(value);
      const contentState = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      setEditorState(EditorState.createWithContent(contentState));
      initializedRef.current = true;
    } else if (!value && initializedRef.current) {
      setEditorState(EditorState.createEmpty());
    }
  }, [value]);

  const handleEditorChange = (newEditorState) => {
    setEditorState(newEditorState);
    const htmlContent = draftToHtml(convertToRaw(newEditorState.getCurrentContent()));
    isSelfUpdateRef.current = true;
    onChange?.(htmlContent);
  };

  return (
    <Editor
      editorState={editorState}
      onEditorStateChange={handleEditorChange}
      placeholder={placeholder}
      toolbarClassName="toolbarClassName"
      wrapperClassName="wrapperClassName"
      editorClassName="editorClassName"
    />
  );
};

export default DescriptionEditor;
